import { fetchQuery, graphql, commitMutation } from "react-relay";
import type { insuranceServiceRequestLogQuery$data as requestLogQueryType } from './__generated__/insuranceServiceRequestLogQuery.graphql'
import type { insuranceServicePlanQuery$data as planQueryType } from './__generated__/insuranceServicePlanQuery.graphql'
import { RelayEnvironment } from "@/RelayEnvironment";
import { useUserStore } from "../store/userStore";
import { PlanType, RequestStatus, RequestType, Tiers } from "../requestDefines";
import { insurance } from "../viewmodel/insurance";

const InsuranceServicePlanQuery = graphql`
query insuranceServicePlanQuery($insuranceid: String!){
    insurance_agent_connection(where: {id: {_eq: $insuranceid}}) {
        edges {
            node {
                id
                name
                orgid
                personalplanexpireddate
                plantype
                insurance_org {
                    expireddate
                    id
                    managerid
                    orgId
                    numberofperson
                    palnType
                    valid
                }
            }
        }
    }
}
`

const InsuranceServiceRequestLogQuery = graphql`
query insuranceServiceRequestLogQuery($insuranceid: String!, $requeststatus: Int!, $queryStart: timestamptz!, $queryEnd: timestamptz!){
  insurance_request_log_connection(where: {
  insuranceid: {_eq: $insuranceid}, 
  created_at: {_gte: $queryStart, _lte: $queryEnd},
  requeststatus: {_neq: $requeststatus}
  }) {
    edges {
      node {
        requeststatus
        requesttype
        recipientid
        insuranceid
        id
      }
    }
  }
}
`

const InsuranceServiceCreateMutation = graphql`
mutation insuranceServiceCreateMutation($userId: String!, $email: String!, $name: String!, $phoneNumbers: [String!]) {
  insert_insurance_agent_one(object: {id: $userId, email: $email, name: $name, phoneNumbers: $phoneNumbers}){
    id
  }
}
`;

const InsuranceServiceUpdateMutation = graphql`
mutation insuranceServiceUpdateMutation($userId: String!, $email: String!, $name: String!, $phoneNumbers: [String!]) {
  update_insurance_agent(where: {id: {_eq: $userId}}, _set: {email: $email, name: $name, phoneNumbers: $phoneNumbers}){
    affected_rows
  }
}
`;

export default function InsuranceService() {

    async function InsertUpdateData(userId: string, name: string, email: string, phoneNumbers: string[]) {
        console.log('InsertUpdateData1');

        await new Promise(async (resolves, reject) => {
            console.log('InsertUpdateData2');
            const planRes = await fetchQuery(RelayEnvironment, InsuranceServicePlanQuery, {
                insuranceid: userId,
            }).toPromise();
            let planData = planRes as planQueryType;

            console.log('planData', planData);

            if (planData.insurance_agent_connection.edges && planData.insurance_agent_connection.edges.length > 0) {

                const updateRes = await commitMutation(RelayEnvironment, {
                    mutation: InsuranceServiceUpdateMutation,
                    variables: {
                        userId: userId,
                        email: email ?? '',
                        name: name ?? '',
                        phoneNumbers: phoneNumbers ?? [],
                    },
                    onCompleted: (response) => {
                        console.log('Success!', response)
                        setTimeout(() => {
                            resolves('finished');
                        }, 1000)
                    },
                    onError: (err) => {
                        console.log('err!', err)
                        reject('error');
                    },
                });
                console.log('updateRes', updateRes);
            } else {

                const insertRes = commitMutation(RelayEnvironment, {
                    mutation: InsuranceServiceCreateMutation,
                    variables: {
                        userId: userId,
                        email: email ?? '',
                        name: name ?? '',
                        phoneNumbers: phoneNumbers ?? [],
                    },
                    onCompleted: (response) => {
                        console.log('Success!', response)
                        setTimeout(() => {
                            resolves('finished');
                        }, 1000)
                    },
                    onError: (err) => {
                        console.log('err!', err)
                        reject('error');
                    },
                });
                console.log('insertRes', insertRes);
            }
        })
    }

    async function InitData(userId: string) {
        console.log('InitData insurance');
        let queryStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        var queryEndDate = new Date(new Date(queryStartDate).setMonth(queryStartDate.getMonth() + 1));
        let insuranceData = new insurance();
        try {
            const planRes = await fetchQuery(RelayEnvironment, InsuranceServicePlanQuery, {
                insuranceid: userId,
                requeststatus: RequestStatus.finish,
                queryStart: queryStartDate,
                queryEnd: queryEndDate,
            }).toPromise();
            let planData = planRes as planQueryType;

            const RequestLogRes = await fetchQuery(RelayEnvironment, InsuranceServiceRequestLogQuery, {
                insuranceid: userId,
                requeststatus: RequestStatus.finish,
                queryStart: queryStartDate,
                queryEnd: queryEndDate,
            }).toPromise();
            let requestLogDatas = RequestLogRes as requestLogQueryType;

            // console.log('planData', planData);
            // console.log('requestLogDatas', requestLogDatas);

            if (planData.insurance_agent_connection.edges && planData.insurance_agent_connection.edges.length > 0) {
                insuranceData.planType = planData.insurance_agent_connection.edges[0].node.plantype;
                insuranceData.orgId = planData.insurance_agent_connection.edges[0].node.orgid ?? "";
                
                if(planData.insurance_agent_connection.edges[0].node.plantype === PlanType.group ){
                    insuranceData.allowUseIntroduce = true;
                }
            }

            let currentTier = Tiers.filter(item => item.planType === insuranceData.planType)[0];
            var aiConsultList = requestLogDatas.insurance_request_log_connection.edges.filter(item => item.node.requesttype === RequestType.aiConsult);
            var careList = requestLogDatas.insurance_request_log_connection.edges.filter(item => item.node.requesttype === RequestType.care);

            insuranceData.remainAiChat = currentTier.aiChatNumbers - (aiConsultList?.length ?? 0);
            insuranceData.remaincare = currentTier.careNumbers - (careList?.length ?? 0);


            useUserStore.setState({ insuranceData: insuranceData });
        } catch (err) {
            console.log('err');
            console.log(err);
        }

    }
    return {
        InitData,
        InsertUpdateData
    };
} 